exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-2b15e914] {\n  margin-top: 5px;\n}", ""]);

// exports
